<script>
  import Inventory from "./Inventory.svelte";
  import Messages from "./Messages.svelte";

  let products = [
    { name: "Dildo 23cm", quantity: 10, status: 1 },
    { name: "Homedical Zwangerschapstest", quantity: 20, status: 1 },
    { name: "C...", quantity: 1500, status: 0, toOpen: "p1" },
    { name: "CD Mega ...", quantity: 3000, status: 0, toOpen: "p2" },
  ];
  let messages = [
    {
      from: "V...",
      subject: "Order update",
      message: "Ik heb het order verzonden",
      status: -1,
      toOpen: "m1",
    },
    {
      from: "Jane Smith",
      subject: "Voorraad alarm",
      message: "Zwangerschapstesten raken op!",
      status: 1,
    },
    {
      from: "Alice Johnson",
      subject: "Maandelijks rapport",
      message: "In de bijlagen vind je het rapport",
      status: 1,
    },
  ];
  let activeTab = "Inventory";

  function onRiddleDone() {
    products = products;
  }

  function setActiveTab(tab) {
    activeTab = tab;
  }
</script>

<div class="logo">
  <img src="images/logo.png" />
</div>

<div class="toolbar">
  <button
    class:active={activeTab === "Inventory"}
    on:click={() => setActiveTab("Inventory")}
    ><img width="16" src="images/products.png" />Inventaris</button
  >
  <button
    disabled={products[3].status != 1}
    class:active={activeTab === "Messages"}
    on:click={() => setActiveTab("Messages")}
    ><img width="16" src="images/messages.png" />Berichten</button
  >
</div>

<div class="content">
  {#if activeTab === "Inventory"}
    <Inventory {products} {onRiddleDone} />
  {:else if activeTab === "Messages"}
    <Messages {messages} />
  {/if}
</div>

<style>
  .content {
    padding-left: 15px;
    padding-right: 15px;
  }
  .toolbar {
    padding-left: 15px;
  }
  .logo {
    text-align: center;
  }
  .logo img {
    max-width: 320px;
    width: 100%;
  }
</style>
